import { Backdrop } from './Backdrop';
import { MessageBox } from './MessageBox';

export class HowToPlayMessage {
  private message;
  private backdrop;
  constructor(scene, gameWidth, gameHeight, cancelCallBack) {
    this.backdrop = new Backdrop(scene);
    const textWidth: number = gameWidth * 0.8 - 25;
    this.message = new MessageBox(
      scene,
      gameWidth * 0.9,
      gameHeight * 0.65,
      [
        { text: 'HOW TO PLAY', fontSize: '40px', yPos: 100, center: true,  color: '#000000' },
        {
          text: '1. Click any of the Call Letters to reveal a letter.',
          fontSize: '28px',
          yPos: 180,
          xPos: 60,
          color: '#000000',
          styles: { wordWrap: { width: textWidth } },
          fontFamily: 'sans-serif'

        },
        {
          text: '2. Click all of the letters found in the puzzle which match the Call Letters',
          fontSize: '28px',
          yPos: 270,
          xPos: 60,
          color: '#000000',
          styles: { wordWrap: { width: textWidth } },
          fontFamily: 'sans-serif'
        },
        {
          text: '3. If you are stuck, click the HINT button to highlight your next possible move.',
          fontSize: '28px',
          yPos: 380,
          xPos: 60,
          color: '#000000',
          styles: { wordWrap: { width: textWidth } },
          fontFamily: 'sans-serif'
        },
        {
          text: '4. If you do not wish to play the game, just click the REVEAL ALL button to solve the full puzzle.',
          fontSize: '28px',
          yPos: 490,
          xPos: 60,
          color: '#000000',
          styles: { wordWrap: { width: textWidth } },
          fontFamily: 'sans-serif'
        },
        {
          text: '5. When you are in "Play for Prizes" mode and you uncover three or more complete words, you win the corresponding prize in the Prize Legend. The Prize Legend can be found in Settings on the game board or on the Home Page navigation bar.',
          fontSize: '28px',
          yPos: 625,
          xPos: 60,
          color: '#000000',
          styles: { wordWrap: { width: textWidth } },
          fontFamily: 'sans-serif'
        }
      ],
      [{ name: 'howtoplayclose', method:this.cancel(cancelCallBack), width: 280, height: 56, x: 580, y: 45 }]

    );
  }

  private cancel = (cancelCallBack) => () => {
    cancelCallBack();
    this.backdrop.destroy();
    this.message.destroy();
  };
}
